export const STUDENT_ENVIRONMENT = 'student';

export const getStudentHostname = (): string =>
  window.location.hostname.toLowerCase();

const getHostnameParts = (hostname: string): string[] =>
  hostname.toLowerCase().split('.').filter(Boolean);

const getStudentEnvironmentIndex = (hostname: string): number => {
  const parts = getHostnameParts(hostname);

  return parts.lastIndexOf(STUDENT_ENVIRONMENT);
};

export const isCoreStudentDomain = (hostname: string = getStudentHostname()): boolean => {
  const parts = getHostnameParts(hostname);
  const studentIndexes = parts
    .map((part, index) => part === STUDENT_ENVIRONMENT ? index : -1)
    .filter(index => index >= 0);

  return studentIndexes.length === 1 && studentIndexes[0] === 0;
};

export const getTenantDomain = (hostname: string = getStudentHostname()): string => {
  const studentIndex = getStudentEnvironmentIndex(hostname);
  const parts = getHostnameParts(hostname);

  return studentIndex > 0 ? parts[studentIndex - 1] : '';
};
